import '../../../shared/StyledInput.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useErrorToast, useDismissError } from '../../../shared/ErrorToastContext';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import FieldHelp from '../../../shared/FieldHelp';
import DateInput from '../../../shared/DateInput';

const sectionStyle = { padding: 16, background: '#fff', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
const sectionHeaderStyle = { margin: '0 0 10px', fontSize: 12, fontWeight: 600, color: '#8a94a6', textTransform: 'uppercase', letterSpacing: 0.6 };

// Receivables Settings: the Invoice Cutover (issue #454), the date Invoices
// and payments move to Optim.
function ReceivablesSettingsPage({ onNavigate }) {
  const showError = useErrorToast();
  const dismissError = useDismissError();
  // '' for none, else a date (a Platform Settings field).
  const [invoiceCutover, setInvoiceCutover] = useState('');
  const [savedInvoiceCutover, setSavedInvoiceCutover] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    axios.get('/api/platform-settings')
      .then((res) => {
        const loaded = res.data?.data?.invoice_cutover || '';
        setInvoiceCutover(loaded);
        setSavedInvoiceCutover(loaded);
      })
      .catch((err) => showError(err, 'Failed to load Receivables Settings'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess('');
    try {
      if (invoiceCutover !== savedInvoiceCutover) {
        await axios.put('/api/platform-settings', { invoice_cutover: invoiceCutover || null });
        setSavedInvoiceCutover(invoiceCutover);
      }
      setSuccess('Receivables Settings saved.');
      dismissError();
    } catch (err) {
      showError(err, 'Save failed');
    }
    setSaving(false);
  };

  const handleCancel = () => {
    setSuccess('');
    if (onNavigate) onNavigate('receivables-dashboard');
  };

  if (loading) {
    return <div style={{ width: '100%', maxWidth: 760, margin: '32px auto' }}>Loading...</div>;
  }

  return (
    <div style={{ width: '100%', maxWidth: 760, margin: '32px auto 48px', background: '#f6f8fa', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: 24 }}>
      <h2 style={{ margin: '0 0 4px', fontWeight: 600, fontSize: 20 }}>Receivables Settings</h2>
      <p style={{ color: '#666', fontSize: 14, marginTop: 0 }}>When Invoices and payments move to Optim.</p>

      <form onSubmit={handleSave} style={{ marginTop: 16 }}>
        <div style={sectionStyle}>
          <h4 style={sectionHeaderStyle}>Invoicing</h4>
          <label htmlFor="invoice_cutover">Invoice Cutover</label><br />
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <DateInput
              id="invoice_cutover"
              className="styled-input"
              value={invoiceCutover}
              onChange={(e) => setInvoiceCutover(e.target.value)}
              style={{ width: 160 }}
            />
            <FieldHelp fieldKey="receivables-setup.invoice-cutover" pageKey="receivables-setup" label="Invoice Cutover">
              A Sales Order dated on or after this date is invoiced at Ship, and its Invoices and Receipts are copied to QuickBooks. An earlier order's Invoice and payment stay in QuickBooks. Setting it never invoices a shipment already made: use Issue Invoice on the shipment for that.
            </FieldHelp>
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
            Blank: nothing is invoiced at Ship or copied to QuickBooks.
          </div>
        </div>

        {success && <div style={{ color: '#2e7d32', marginTop: 12 }}>{success}</div>}

        <div style={{ marginTop: 16 }}>
          <SaveButton loading={saving} />
          <CancelButton onClick={handleCancel} disabled={saving} style={{ marginLeft: 8 }} />
        </div>
      </form>
    </div>
  );
}

export default ReceivablesSettingsPage;
